import VaultBaseController from '../common/vault.base.controller'

class VaultCreateController extends VaultBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, VaultService, Modal, $translate) {
		super(Auth, $state, User, VaultService, Modal, $translate)

		this.model.id = ''
		this.model.description = ''
	}

	reset() {
		for (let key in this.model) {
			this.model[key] = ''
		}

		this.clearErrors()
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}

		this.loading = true
		this.Service.create({
				id: this.model.id,
				description: this.model.description
			})
			.then((data) => {
				this.loading = false
				this.askCreate()
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}
}

export default VaultCreateController;


// WEBPACK FOOTER //
// ./client/app/components/vault/create/vault.create.controller.js